import React from 'react';
import { AlbumSection } from '../components/AlbumSection';
import { Countdown } from '../components/Countdown';

export const AlbumPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-950 via-gray-900 to-black pt-24">
      <div className="container mx-auto px-4 lg:px-8 py-8">
        <Countdown />
      </div>
      <AlbumSection />
    </div>
  );
};